<div class="container-fluid">
  <div class="row" style="height: 100vh">
    <!-- Image Div: Only visible on medium (md) and large (lg) screens -->
    <div class="col-md-6 d-none d-md-block" style="
        background-image: url('../../../assets/images/newLogin_IMAGE.jpg');
        background-size: cover;
        background-position: center;
      "></div>

    <!-- Form Div: Always visible -->
    <div class="col-md-6 d-flex align-items-center">
      <div class="w-100 p-4" *ngIf="signInScreen == true">
        <div class="back_Div mb-3" (click)="backScreen()">
          <img src="../../../assets/images/IconleftTurn.svg" /> Back
        </div>
        <img src="../../../assets/images/logo_without_Text2.svg" class="logo_Img" />
        <p class="login_Text mt-4">Login</p>
        <form [formGroup]="loginForm">
          <div class="form-group mt-5">
            <label for="email">Email Address</label>
            <input type="email" class="form-control form_Input mt-2" id="email" placeholder="i.e. davon@mail.com"
              formControlName="email" />
            <div style="height: 15px;">
              <div *ngIf="
                loginForm.controls['email'].invalid &&
                (loginForm.controls['email']?.dirty ||
                  loginForm.controls['email']?.touched)
              " class="errorinput text-left">
                <div *ngIf="loginForm.controls['email'].errors.required">
                  *Email is required.
                </div>
                <div *ngIf="loginForm.controls['email'].errors.pattern">
                  *Invalid email .
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mt-4">
            <label for="password">Password</label>
            <div class="password-container">
              <input [type]="passwordVisible ? 'text' : 'password'" class="form-control form_Input mt-2" id="password"
                formControlName="password" placeholder="********" />
              <img src="{{
                  passwordVisible
                    ? 'assets/images/eye.svg'
                    : 'assets/images/eye-slash.svg'
                }}" alt="Toggle password visibility" class="toggle-password" (click)="togglePasswordVisibility()" />
            </div>
            <div style="height: 15px;">
              <div *ngIf="
                loginForm.controls['password'].invalid &&
                (loginForm.controls['password']?.dirty ||
                  loginForm.controls['password']?.touched)
              " class="errorinput text-left">
                <div *ngIf="loginForm.controls['password'].errors.required">
                  *Password is required.
                </div>
                <div *ngIf="loginForm.controls['password'].errors.minlength">
                  *Minimum password length is 8.
                </div>
              </div>
            </div>
          </div>

          <div class="form-group form-check mt-4">
            <div class="row">
              <div class="col-6">
                <input type="checkbox" class="form-check-input" id="rememberMe" />
                <label class="form-check-label" for="rememberMe">Remember me</label>
              </div>
              <div class="col-6 forgetPassword text-end" routerLink="/auth/forget-password">
                Forgot Password?
              </div>
            </div>
          </div>

          <div class="button_div mt-5">
            <button [disabled]="!loginForm.valid" type="submit" class="btn btn-primary btn-Login" (click)="login()">
              <span *ngIf="isLoading">loading...</span> <span *ngIf="!isLoading">
                Login <img src="../../../assets/images/IconRightturn.svg" />
              </span>
            </button>
          </div>
        </form>
        <!-- <p class="mt-3">
          Don't have an account?
          <span style="color: #f0a500; cursor: pointer" routerLink="/auth/signup">Signup</span>
        </p> -->
      </div>
      <div class="w-100 p-4 user_Form" *ngIf="userDetailScreen == true && signInScreen == false">
        <!-- <div class="back_Div mb-3">
          <img src="../../../assets/images/IconleftTurn.svg" /> Back
        </div> -->
        <img src="../../../assets/images/full_color_logo_title_tagline 1.svg" class="logo_Img" />
        <p class="login_Text mt-4">Enter Parent Details</p>
        <form [formGroup]="userForm">
          <div class="form-group mt-2">
            <label class="profile_Pic_Label cursor">
              <img src="{{
                  storeImage
                    ? storeImage
                    : '../../../assets/images/dummy_Pic.svg'
                }}" style="height: 150px; width: 150px; border-radius: 10px" />
              <p class="profile_Pic_Text">+ Add Profile Photo</p>
              <input #Btn type="file" accept="image/*" class="profile_Pic_Input" formControlName="profilePic"
                (change)="fileChangeEvent($event, addedactivities, Btn)" hidden />
            </label>

            <div *ngIf="userForm.controls['profilePic'].invalid" class="errorinput text-left">
              <div *ngIf="userForm.controls['profilePic'].errors.required">
                *Profile Pic is required.
              </div>
              <!-- <div *ngIf="userForm.controls['firstName'].errors.pattern">
                *Invalid First Name .
              </div> -->
            </div>
          </div>
          <div class="form-group mt-2">
            <label for="firstName">First Name</label>
            <input type="firstName" class="form-control form_Input mt-2" id="firstName" placeholder="Enter First Name"
              formControlName="firstName" />
            <div *ngIf="
                userForm.controls['firstName'].invalid &&
                (userForm.controls['firstName']?.dirty ||
                  userForm.controls['firstName']?.touched)
              " class="errorinput text-left">
              <div *ngIf="userForm.controls['firstName'].errors.required">
                *First Name is required.
              </div>
              <!-- <div *ngIf="userForm.controls['firstName'].errors.pattern">
                *Invalid First Name .
              </div> -->
            </div>
          </div>
          <div class="form-group mt-2">
            <label for="LastName">Last Name</label>
            <input type="lastName" class="form-control form_Input mt-2" id="lastName" placeholder="Enter Last Name"
              formControlName="lastName" />
            <div *ngIf="
                userForm.controls['lastName'].invalid &&
                (userForm.controls['lastName']?.dirty ||
                  userForm.controls['lastName']?.touched)
              " class="errorinput text-left">
              <div *ngIf="userForm.controls['lastName'].errors.required">
                *Last Name is required.
              </div>
              <!-- <div *ngIf="userForm.controls['firstName'].errors.pattern">
                *Invalid First Name .
              </div> -->
            </div>
          </div>
          <!-- <div class="form-group mt-2">
            <label for="password">Password</label>
            <input
              type="password"
              class="form-control form_Input mt-2"
              id="password"
              formControlName="password"
              placeholder="********"
            />
            <div
              *ngIf="
                userForm.controls['password'].invalid &&
                (userForm.controls['password']?.dirty ||
                  userForm.controls['password']?.touched)
              "
              class="errorinput text-left"
            >
              <div *ngIf="userForm.controls['password'].errors.required">
                *Password is required.
              </div>
              <div *ngIf="userForm.controls['password'].errors.minlength">
                *Minimum password length is 8.
              </div>
            </div>
          </div> -->
          <!-- <div class="form-group form-check mt-4">
            <input type="checkbox" class="form-check-input" id="rememberMe" />
            <label class="form-check-label" for="rememberMe">Remember me</label>
          </div> -->
          <div class="button_div mt-4">
            <button [disabled]="!userForm.valid" type="submit" class="btn btn-primary btn-Login"
              (click)="ContinueToNext()">
              Continue <img src="../../../assets/images/IconRightturn.svg" />
            </button>
          </div>
        </form>
      </div>
      <div class="w-100 p-4 user_Form" *ngIf="
          userDetailScreen2 == true &&
          signInScreen == false &&
          userDetailScreen == false
        ">
        <!-- <div class="back_Div mb-3">
          <img src="../../../assets/images/IconleftTurn.svg" /> Back
        </div> -->
        <img src="../../../assets/images/full_color_logo_title_tagline 1.svg" class="logo_Img" />
        <p class="login_Text mt-4">Child Details</p>
        <form [formGroup]="userForm">
          <!-- <div class="form-group mt-2">
            <label class="profile_Pic_Label cursor">
              <img src="../../../assets/images/dummy_Pic.svg" />
              <p class="profile_Pic_Text">+ Add Profile Photo</p>
              <input
                type="file"
                accept="image/*"
                class="profile_Pic_Input"
                hidden
              />
            </label>

            <div
              *ngIf="
                userForm.controls['profilePic'].invalid &&
                (userForm.controls['profilePic']?.dirty ||
                  userForm.controls['profilePic']?.touched)
              "
              class="errorinput text-left"
            >
              <div *ngIf="userForm.controls['profilePic'].errors.required">
                *First Name is required.
              </div>
            
            </div>
          </div> -->
          <div class="form-group mt-2">
            <label for="numberOfKids">No. Of Kids</label>
            <input type="number" class="form-control form_Input mt-2" id="numberOfKids"
              placeholder="Enter No. Of Children" [(ngModel)]="numberOfKids" [ngModelOptions]="{ standalone: true }"
              (input)="generateChildControls()" min="0" (wheel)="onScroll($event)" />
            <!-- <div
              *ngIf="
                userForm.controls['numberOfKids'].invalid &&
                (userForm.controls['numberOfKids']?.dirty ||
                  userForm.controls['numberOfKids']?.touched)
              "
              class="errorinput text-left"
            >
              <div *ngIf="userForm.controls['numberOfKids'].errors.required">
                *No. of Kids is required.
              </div>
            <div *ngIf="userForm.controls['firstName'].errors.pattern">
                *Invalid First Name .
              </div>
            </div> -->
          </div>
          <!-- <div
            class="childCount"
           
          > -->
          <app-spinner *ngIf="isSpinnerVisible" [type]="'normal'"></app-spinner>

          <div class="count_Div mt-4 mb-4 d-flex" *ngIf="childArray?.length">
            <div class="main_Child_count_Div ml-2 mr-2 cursor" *ngFor="let child of childArray; let i = index"
              [ngClass]="{
                main_Child_count_Div_hover:
                  i === hoveredIndex || i === currentChildIndex
              }" (click)="selectChild(i)" (mouseenter)="onMouseEnter(i)" (mouseleave)="onMouseLeave()">
              Child {{ i + 1 }}
            </div>
          </div>

          <div class="form-group mt-2" *ngIf="childArray?.length">
            <label class="profile_Pic_Label cursor">
              <img [src]="
                  selectedChild?.profilePic
                    ? selectedChild?.profilePic
                    : '../../../assets/images/dummy_Pic.svg'
                " style="height: 150px; width: 150px; border-radius: 10px" />
              <p class="profile_Pic_Text">+ Add Profile Photo</p>
              <input #Btn type="file" accept="image/*" class="profile_Pic_Input" formControlName="profilePic"
                (change)="fileChangeEvent2($event, addKid, Btn, i)" hidden />
            </label>
          </div>

          <div class="form-group mt-2" *ngIf="childArray?.length">
            <label for="firstName">First Name</label>
            <input type="text" class="form-control form_Input mt-2" id="firstName" placeholder="Enter First Name"
              [(ngModel)]="selectedChild.firstName" [ngModelOptions]="{ standalone: true }" required />
            <div *ngIf="
                !selectedChild.firstName &&
                (firstName?.dirty || firstName?.touched)
              " class="errorinput text-left">
              *First Name is required.
            </div>
          </div>

          <div class="form-group mt-2" *ngIf="childArray?.length">
            <label for="lastName">Last Name</label>
            <input type="text" class="form-control form_Input mt-2" id="lastName" placeholder="Enter Last Name"
              [(ngModel)]="selectedChild.lastName" [ngModelOptions]="{ standalone: true }" required />
            <div *ngIf="
                !selectedChild.lastName &&
                (lastName?.dirty || lastName?.touched)
              " class="errorinput text-left">
              *Last Name is required.
            </div>
          </div>

          <div class="d-flex" *ngIf="childArray?.length">
            <div class="form-group mt-2 px-2 col-md-6">
              <label for="age">Age</label>
              <input type="number" class="form-control form_Input mt-2" id="age" placeholder="Enter Age"
                [(ngModel)]="selectedChild.age" [ngModelOptions]="{ standalone: true }" min="0"
                (wheel)="onScroll($event)" required />
              <div *ngIf="!selectedChild.age && (age?.dirty || age?.touched)" class="errorinput text-left">
                *Age is required.
              </div>
            </div>

            <div class="form-group mt-2 col-md-6">
              <label for="gender">Gender</label>
              <select class="form-control form_Input mt-2" id="gender" [(ngModel)]="selectedChild.gender"
                [ngModelOptions]="{ standalone: true }" required>
                <option value="" disabled>Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
              <div *ngIf="
                  !selectedChild.gender && (gender?.dirty || gender?.touched)
                " class="errorinput text-left">
                *Gender is required.
              </div>
            </div>
          </div>

          <button [disabled]="childArray?.length == 0" class="btn btn-primary btn-Login mt-5"
            (click)="onContinuetoDetail()">
            Continue <img src="../.././../assets/images/IconRightturn.svg" />
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
<ng-template #addedactivities let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">User Image</h5>
    <button type="button" class="close btn cross_btn" data-dismiss="modal" (click)="closeModal('dismiss')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 mt-2 pe-5 ps-5">
      <div class="cropper" *ngIf="imageChangedEvent">
        <h5 class="cropper-title">Crop Image</h5>
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
          cropperMinWidth="200" cropperMinHeight="200" resizeToWidth="600" resizeToHeight="600" format="png"
          (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()">
        </image-cropper>
        <!-- <button class="btn btn-danger mr-rt-1x" (click)="cancel()">
          Cancel
        </button> -->
        <div class="savebtn mt-4 d-flex justify-content-center">
          <button (click)="save()" class="btn btn-Login ml-2">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #addKid let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">Kid Image</h5>
    <button type="button" class="close btn cross_btn" data-dismiss="modal" (click)="closeModal('dismiss')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 mt-2 pe-5 ps-5">
      <div class="cropper" *ngIf="imageChangedEvent2">
        <h5 class="cropper-title">Crop Image</h5>
        <image-cropper [imageChangedEvent]="imageChangedEvent2" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
          cropperMinWidth="200" cropperMinHeight="200" resizeToWidth="600" resizeToHeight="600" format="png"
          (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()">
        </image-cropper>
        <!-- <button class="btn btn-danger mr-rt-1x" (click)="cancel()">
          Cancel
        </button> -->
        <div class="savebtn mt-4 d-flex justify-content-center">
          <button (click)="save2()" class="btn btn-Login ml-2">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>